import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import defaultCardImage from "images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomizeIconImage from "images/customize-icon.svg";
import FastIconImage from "images/fast-icon.svg";
import ReliableIconImage from "images/reliable-icon.svg";
import SimpleIconImage from "images/simple-icon.svg";
import GridWithFeaturedPost from "components/blogs/GridWithFeaturedPost";

import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";

import default_image from "images/unavailable-img.jpg";


// import MicrovesselModelVideo from "images/microvessel-model-video.mp4"
const Container = tw.div`relative`;
const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-0 md:py-0`}
`;

const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;


const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-100 leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
  padding-bottom: 56.25% !important;
  padding-top: 0px !important;
  ${tw`rounded`}
  iframe {
    ${tw`rounded bg-black shadow-xl`}
  }
`;

const ImageSlider = styled(Slider)`
  ${tw`flex mt-16 mx-auto max-w-xs sm:max-w-xl lg:max-w-4xl text-left bg-gray-100 rounded-lg text-gray-900`}
  .slick-track {
    ${tw`flex!`}
  }
  .slick-slide {
    ${tw`h-auto`}
  }
  .slick-slide > div {
    ${tw`h-full`}
  }
  .slick-slider {
    display: block !important;
  }
  .slick-track div {
    display: flex;
    justify-content: center;
  }
  div[tabindex] {
    display: flex !important;
  }
`;


const sliderSettings = {
  infinite: true,
  speed: 0,
  arrows: false,
  slidesToScroll: 1,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  previous: null,
  cssEase: 'lineaer', // disable CSS Transitions
};


export default ({ cards = null, heading = "Amazing Features", subheading = "Features", description = "Descp", 
                  itemCode = "0", product = "prod", specs = ["1","2","3"], qtt = "qtt", imgSrc1 = default_image, imgSrc2 = default_image, imgSrc3 = null
                }) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  // const defaultCards = [
  //   {
  //     imageSrc: ShieldIconImage,
  //     title: "Secure",
  //     description: "We strictly only deal with vendors that provide top notch security."
  //   },
  //   { imageSrc: SupportIconImage, title: "24/7 Support" },
  //   { imageSrc: CustomizeIconImage, title: "Customizable" },
  //   { imageSrc: ReliableIconImage, title: "Reliable" },
  //   { imageSrc: FastIconImage, title: "Fast" },
  //   { imageSrc: SimpleIconImage, title: "Easy" }
  // ];

  // if (!cards) cards = defaultCards;

  return (
    <Container>
      <ThreeColumnContainer >
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {/* {description && <Description>{description}</Description>} */}
        <VerticalSpacer />
      
      </ThreeColumnContainer>

      <ImageSlider {...sliderSettings} style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
        <div>
          <img src={imgSrc1} width="50%" height="50%" objectFit='cover' />
        </div>
        <div>  
            <img src={imgSrc2} width="50%" height="50%" objectFit='cover' />
        </div>
        {imgSrc3 && (
          <div>
            <img src={imgSrc3} width="50%" height="50%" objectFit='cover' />
          </div>
        )}
      </ImageSlider>
    
        
        {/* <StyledResponsiveVideoEmbed
                url="https://www.youtube.com/embed/K4TOrB7at0Y"
                
                background="transparent"
        /> */}



      <DecoratorBlob />
      
    </Container>
  );
};
